import { NavigateOptions, To, useNavigate as useRouterNavigate } from "react-router-dom";

import { useUnsafeNavigationControls } from "./use-navigation-control-context";

export function useNavigate() {
  const routerNavigate = useRouterNavigate();
  const maybeNavigationControls = useUnsafeNavigationControls();

  const navigate = (to: To, options?: NavigateOptions) => {
    // Track the navigation
    maybeNavigationControls?.trackNavigation(typeof to === "string" ? to : to.pathname || "", {
      replace: options?.replace,
    });

    // Then perform the actual navigation using the router's navigate
    routerNavigate(to, options);
  };

  return navigate;
}
